import React from "react";

const AboutPage = () => {
    return (
        <h1>About - to be implemented</h1>
    )
}

export default AboutPage;